// extracted by mini-css-extract-plugin
module.exports = {"sliderHandles":"_060977f","button":"_99a943f","hideArrows":"_4d2e9df","show":"_60a38c8","right":"_e9499d1"};